import styled    from 'styled-components'
import { Alert } from 'antd'

const SSAlert = styled(Alert)`
  white-space: normal;

  ${(props) => {
    if (props.type === 'error') {
      return `
        color: rgba(0, 0, 0, 0.65) !important;
        border: 1px solid #ffa39e !important;
        background-color: #fff1f0 !important;
      `
    }
  }}

  ${(props) => {
    if (props.small) {
      return `
        &.ant-alert {
          padding: 8px;
        }

        .ant-alert-message {
          font-size: 12px;
        }

        .ant-alert-icon {
          position: relative;
          top: 0px;
          left: 0px; 
          margin-right: 5px;
          vertical-align: middle;
        }
      `
    }
  }}
`

export default SSAlert
